import React, { useState, useContext} from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, Button, TextField, IconButton, FormControlLabel, Checkbox } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { UserContext } from '../contexts/UserContext'; // Import the UserContext

const AuthModal = ({ showAuthModal, setShowAuthModal }) => {
  const { setUserInfo } = useContext(UserContext); // Access setUserInfo from UserContext

  const [isLogin, setIsLogin] = useState(true); // Toggle between login and signup
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [signedToNewsletter, setSignedToNewsletter] = useState(true); // Default to true
  const [signUpMessage, setSignUpMessage] = useState('')
  const [singingIn, setSigningIn] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false)

  async function login(ev) {

    ev.preventDefault();
    setIsLoggingIn(true)   
    const response = await fetch(`${process.env.REACT_APP_API_END_POINT}/login`, {
      method: "POST",
      body: JSON.stringify({ username, password }),
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });

    if (response.ok) {
      response.json().then((userInfo) => {
        setUserInfo(userInfo);
        setShowAuthModal(false); // Close the modal
      });
    } else {
      setSigningIn(true)
      setSignUpMessage("Wrong credentials");
    }
    setIsLoggingIn(false)
  }

  async function register(ev) { 
    ev.preventDefault();
    
    try {
      setSigningIn(true)
      // Step 1: Register the user
      const registerResponse = await fetch(`${process.env.REACT_APP_API_END_POINT}/register`, {
        method: 'POST',
        body: JSON.stringify({ username, password, email, signedToNewsletter }),
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include' // Include cookies for session handling
      });
      
      const registerData = await registerResponse.json();
      
      if (registerResponse.status === 201) {
        // If registration is successful, log in the user automatically
        setSignUpMessage('Registration successful! Logging you in...');
        setIsLoggingIn(true);
  
        // Step 2: Automatically log in the user after successful registration
        const loginResponse = await fetch(`${process.env.REACT_APP_API_END_POINT}/login`, {
          method: 'POST',
          body: JSON.stringify({ username, password }),
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include' // Include cookies for session handling
        });
  
        if (loginResponse.ok) {
          // Step 3: Handle successful login
          const userInfo = await loginResponse.json();
          setUserInfo(userInfo); // Update user context or state
          setShowAuthModal(false); // Close the modal
        } else {
          const loginData = await loginResponse.json();
          setSignUpMessage(`Login failed: ${loginData.message || 'Please try logging in manually.'}`);
        }
        
      } else if (registerResponse.status === 400 && registerData.message === 'Username already taken') {
        // Handle if the username is already taken
        setSignUpMessage('Registration failed: Username is already taken.');
      } else {
        // Generic error message for registration failure
        setSignUpMessage(`Registration failed: ${registerData.message || 'Please try again.'}`);
      }
      
    } catch (err) {
      // Catch and display any network or unexpected errors
      setSignUpMessage('An unexpected error occurred. Please try again.');
    } finally {
      
      
    }
  }

  if (!showAuthModal) return null;
  return (
    <Dialog open={showAuthModal} onClose={() => setShowAuthModal(false)}>
  {/* Header with orange background */}
  <DialogTitle sx={{ backgroundColor: '#ca7735', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
    <IconButton className='post-icon' onClick={() => setShowAuthModal(false)}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  {/* Modal Content */}
  <DialogContent sx={{ my: '5%' }}>
    <Typography variant="h6" gutterBottom>
      {isLogin ? 'Please login to your account first' : 'Create a new account'}
    </Typography>
    <Typography variant="body1" gutterBottom>
      {isLogin ? '' : 'Enter your email and password below to create your account'}
    </Typography>

    {singingIn && (
        <Typography variant="body1" gutterBottom className="msg">
       { signUpMessage}
          </Typography>
  
        )}

    {/* Form Fields */}
    <TextField
      label="Username"
      fullWidth
      margin="normal"
      value={username}
      onChange={(e) => setUsername(e.target.value)}
    />
    <TextField
      label="Password"
      type="password"
      fullWidth
      margin="normal"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
    />

    {/* Conditional Rendering for Sign Up Fields */}
    {!isLogin && (
      <>
        {/* Email Field for Sign Up */}
        <TextField
          margin="normal"
          fullWidth
          label="Email"
          value={email}
          onChange={(ev) => setEmail(ev.target.value)}
        />
        {/* Checkbox for signing up to newsletter */}
        <FormControlLabel
          control={
            <Checkbox
              checked={signedToNewsletter}
              onChange={(e) => setSignedToNewsletter(e.target.checked)}
              sx={{
                '&.MuiCheckbox-root.Mui-checked': { color: '#d3752b' },
              }}
            />
          }
          label="Sign me up to the newsletter."
        />
        <Typography variant="body2" sx={{ textAlign: 'start', mb: 3 }}>
          You'll receive personalized recommendations about recipes, cooking tips, and much more.
        </Typography>
      </>
    )}

    {/* Sign In or Sign Up Button */}
    <Button
      disabled={!username || !password || (!isLogin && !email)}
      className='unit-btn active mt-3'
      variant="contained"
      color="primary"
      fullWidth
      onClick={isLogin ? login : register}
      sx={{ marginTop: '16px' }}
    >
      {isLogin ? 'Log In' : 'Sign Up'}
    </Button>

    {/* Toggle Between Login and Signup */}
    <Typography variant="body2" align="center" sx={{ marginTop: '16px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {isLogin ? (
        <>
          Don't have an account?{' '}
          <button
            style={{ color: '#ca7735', width: 'fit-content', backgroundColor: 'unset', marginLeft: '1rem', fontStyle: 'bold', fontWeight: '700' }}
            onClick={() => setIsLogin(false)}
          >
            Sign Up
          </button>
        </>
      ) : (
        <>
          Already have an account?{' '}
          <button
            style={{ color: '#ca7735', width: 'fit-content', backgroundColor: 'unset', marginLeft: '1rem', fontStyle: 'bold', fontWeight: '700' }}
            onClick={() => setIsLogin(true)}
          >
            Log In
          </button>
        </>
      )}
    </Typography>
  </DialogContent>
</Dialog>

  );
};

export default AuthModal;
